export default "__VITE_ASSET__CruvNl5R__"